module.exports = {"id":"137960","name":"Yann Jouffre","rating":"72","photo":"./data/images/photos/1/137960.png","club":{"name":"FC Metz","logo":"./data/images/clubs/FCMetz.png"},"positions":["MD","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YannJouffre0.json
// module id = 4381
// module chunks = 0